<template>
    <scrollBox 
    :data="data" 
    :loading="loading" 
    :total="total"
    :showMore="showMore"
    @loadMore="$emit('loadMore')">
        <template #left="scope">
            <file-record :title="fileName(scope.row.fileUrl)" :url="scope.row.fileUrl" :size="scope.row.fileSize || '未知'" :fileType="scope.row.fileExt" type="left"></file-record>
        </template>
        <template #right="scope">
            <file-record :title="fileName(scope.row.fileUrl)" :url="scope.row.fileUrl" :size="scope.row.fileSize || '未知'" :fileType="scope.row.fileExt" type="right"></file-record>
        </template>
    </scrollBox>
</template>
<script>
import scrollBox from './lib/scroll-box.vue'
import scrollBox2 from './lib/scroll-box2.vue'
import fileRecord from './lib/file-record.vue'
export default {
    components: { scrollBox,scrollBox2, fileRecord},
    props: {
        data: {
            type: Array,
            default() { return [] }
        },
        total: {
            type: Number,
            default() { return 0 }
        },
        loading: {
            type: Boolean,
            default() { return false }
        },
        showMore: {
            type: Boolean,
            default() { return false }
        }
    },
    computed: {
        fileName() {
            return function(url) {
                if(!url) return ''
                let index = url.lastIndexOf('/')
                return url.slice(index+1)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>